import slice from './account.slice'

export const selectSlice = (state) => state[slice.name]

export const selectAccountUsers = (state) => selectSlice(state).accountUsers

export const selectAccountModal = (state) => selectSlice(state).accountModal

export const SelectAddUserModal = (state) => selectSlice(state).isAddUserModal

export const SelectBackOfficeAccounts = (state) =>
	selectSlice(state).backOfficeAccounts

export const selectEmail = (state) => selectSlice(state).email

export const selectSelectedRow = (state) => selectSlice(state).selectedRow

export const selectFFLDetails = (state) => selectSlice(state).fflDetails

export const selectuserManualFile = (state) => selectSlice(state).userManualFile

export const selectSelectedAccount = (state) =>
	selectSlice(state).selectedAccount
